import Image from '@tiptap/extension-image';
import Link from '@tiptap/extension-link';
import {
  ORIGINAL_MEDIA_HREF_ATTR,
  ORIGINAL_MEDIA_SRC_ATTR,
  RESOLVED_MEDIA_ATTR,
} from './richTextMediaHelpers';

export const ImageWithOriginalSrc = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) => (attributes.style ? { style: attributes.style } : {}),
      },
      [ORIGINAL_MEDIA_SRC_ATTR]: {
        default: null,
        parseHTML: (element) => element.getAttribute(ORIGINAL_MEDIA_SRC_ATTR),
        renderHTML: (attributes) => {
          const originalSrc = attributes[ORIGINAL_MEDIA_SRC_ATTR];
          return originalSrc ? { [ORIGINAL_MEDIA_SRC_ATTR]: originalSrc } : {};
        },
      },
      [RESOLVED_MEDIA_ATTR]: {
        default: null,
        parseHTML: (element) => element.getAttribute(RESOLVED_MEDIA_ATTR),
        renderHTML: (attributes) => {
          const resolvedMedia = attributes[RESOLVED_MEDIA_ATTR];
          return resolvedMedia ? { [RESOLVED_MEDIA_ATTR]: resolvedMedia } : {};
        },
      },
    };
  },
});

export const LinkWithOriginalHref = Link.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      [ORIGINAL_MEDIA_HREF_ATTR]: {
        default: null,
        parseHTML: (element) => element.getAttribute(ORIGINAL_MEDIA_HREF_ATTR),
        renderHTML: (attributes) => {
          const originalHref = attributes[ORIGINAL_MEDIA_HREF_ATTR];
          return originalHref ? { [ORIGINAL_MEDIA_HREF_ATTR]: originalHref } : {};
        },
      },
      [RESOLVED_MEDIA_ATTR]: {
        default: null,
        parseHTML: (element) => element.getAttribute(RESOLVED_MEDIA_ATTR),
        renderHTML: (attributes) => {
          const resolvedMedia = attributes[RESOLVED_MEDIA_ATTR];
          return resolvedMedia ? { [RESOLVED_MEDIA_ATTR]: resolvedMedia } : {};
        },
      },
    };
  },
});
